import React from "react";
import { Check } from "lucide-react";
import { KpiCard } from "./BillableKpiStrip.jsx";
import { WorkspaceKpis } from "./WorkspaceBand.jsx";
import { invoiceGroup } from "./InvoiceCards.jsx";
import { invoiceDisplayStatus } from "../../utils/billingPresentation.js";

function money(value, currency = "CAD") {
  return new Intl.NumberFormat("fr-CA", { style: "currency", currency }).format(Number(value || 0));
}

const plural = (count, word) => `${count} ${word}${count > 1 ? "s" : ""}`;
const total = (rows) => rows.reduce((sum, invoice) => sum + Number(invoice.total || 0), 0);
// Date locale « AAAA-MM » d'un horodatage (envoi, annulation).
const monthOf = (value) => {
  const date = value ? new Date(value) : null;
  return date && !Number.isNaN(date.getTime()) ? `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}` : "";
};
const monthName = (month) => new Intl.DateTimeFormat("fr-CA", { month: "long" }).format(new Date(`${month}-15T12:00:00`));

/** Brouillon → Envoyé → Annulé, sur les relevés affichés. Un clic ouvre le premier relevé de la case. */
export default function InvoiceKpiStrip({ busy = false, invoices = [], month = "", onSelect }) {
  const fix = invoices.filter((invoice) => invoiceGroup(invoice) === "fix");
  const ready = invoices.filter((invoice) => invoiceGroup(invoice) === "ready");
  const sent = invoices.filter((invoice) => ["sent", "paid"].includes(invoiceDisplayStatus(invoice)) && monthOf(invoice.sent_at) === month);
  const voided = invoices.filter((invoice) => invoiceDisplayStatus(invoice) === "void" && monthOf(invoice.voided_at) === month);
  const inMonth = month ? ` en ${monthName(month)}` : "";
  const open = (rows) => () => { if (rows[0]) onSelect?.(rows[0].id); };
  return (
    <WorkspaceKpis label="Indicateurs des relevés" className="max-sm:!grid-cols-1">
      <KpiCard disabled={busy} label="À corriger" tone="blocked" onClick={open(fix)}
        primary={money(total(fix))} primaryTone={fix.length ? "danger" : "neutral"}
        secondary={fix.length ? `${plural(fix.length, "brouillon")} ${fix.length > 1 ? "bloqués" : "bloqué"}` : "Aucun brouillon bloqué"} />
      <KpiCard disabled={busy} label="Prêts à envoyer" tone="done" onClick={open(ready)}
        primary={money(total(ready))}
        secondary={ready.length ? `${plural(ready.length, "relevé")} ${ready.length > 1 ? "prêts" : "prêt"}` : "Aucun relevé prêt"} />
      <KpiCard disabled={busy} label={`Envoyés${inMonth}`} tone="done" icon={Check} onClick={open(sent)}
        primary={money(total(sent))} secondary={plural(sent.length, "relevé")} />
      <KpiCard disabled={busy} label={`Annulés${inMonth}`} tone="void" onClick={open(voided)}
        primary={money(total(voided))} secondary={plural(voided.length, "relevé")} />
    </WorkspaceKpis>
  );
}
